module.exports = __webpack_public_path__ + "static/media/file_placeholder.198991c6.jpg";